import { CircularProgress, Pagination, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../../locales/tokens";
import { SearchInput } from "../../../../../ui-kit/searchInput/searchInput";
import { useAnswers } from "../presenter/useAnswers";
import { UserCard } from "./components/userCard";
import { QuestionCard } from "./components/questionCard";
import { AnswerCard } from "./components/answerCard";
import { EmptyPage } from "../../../category/categoryEmpty/ui";

export const Answers = () => {
  const { t } = useTranslation();
  const {
    isLoading,
    answerLoading,
    data,
    singleTest,
    searchValue,
    handleSearch,
    handleSetResult,
    getCurrentAnswers,
    answers,
    handlePageChange,
    pageAmount,
    page,
  } = useAnswers();

  if (!isLoading && data.length === 0 && searchValue === null) {
    return (
      <EmptyPage
        title={t(tokens.test.emptyTitle)}
        description={t(tokens.test.emptyDescr)}
      />
    );
  }

  return (
    <Stack p={2}>
      <Stack mb={4}>
        <Typography mb={2} variant="h5" fontWeight={600}>
          {singleTest?.name}
        </Typography>

        <SearchInput
          searchText={searchValue || ""}
          label={t(tokens.test.searchTestByName)}
          handleSearch={handleSearch}
          size="small"
        />
      </Stack>
      {isLoading ? (
        <Stack mt={3} alignItems="center">
          <CircularProgress />
        </Stack>
      ) : (
        <Stack>
          {data.length !== 0 ? (
            <>
              {data.map(({ id, attempts, ...item }) => (
                <UserCard key={id} id={id} {...item}>
                  <Stack pl={4} p={2}>
                    {attempts && attempts?.length > 0 ? (
                      attempts.map((item, index) => (
                        <QuestionCard
                          key={id + item.id}
                          id={item.id}
                          name={`${t(tokens.test.attempt)} ${index + 1}`}
                          date={item.endTime}
                          isLoading={answerLoading.includes(String(item.id))}
                          getCurrentAnswers={getCurrentAnswers}
                        >
                          {answers?.[item.id]?.userQuestion?.length > 0 ? (
                            answers[item.id].userQuestion.map(
                              ({ answers, question }: any) => (
                                <Stack>
                                  <Typography
                                    fontWeight={600}
                                    pt={1}
                                    pb={0.5}
                                    pl={2}
                                    variant="body2"
                                  >
                                    {question.title}
                                  </Typography>
                                  {answers?.length > 0 ? (
                                    answers.map((answer: any) => (
                                      <AnswerCard
                                        key={answer.id}
                                        {...answer}
                                        handleSetResult={handleSetResult}
                                        id={item.id}
                                      />
                                    ))
                                  ) : (
                                    <Typography py={1} px={2} variant="body2">
                                      {t(tokens.test.noAnswers)}
                                    </Typography>
                                  )}
                                </Stack>
                              )
                            )
                          ) : (
                            <Typography py={1} px={2} variant="body2">
                              {t(tokens.test.noAnswers)}
                            </Typography>
                          )}
                        </QuestionCard>
                      ))
                    ) : (
                      <Typography variant="body2">
                        {t(tokens.test.noAttempts)}
                      </Typography>
                    )}
                  </Stack>
                </UserCard>
              ))}
              {pageAmount > 1 && (
                <Stack alignItems="center" justifyContent="center" mt={2}>
                  <Pagination
                    page={page}
                    count={pageAmount || 1}
                    onChange={handlePageChange}
                    color="primary"
                  />
                </Stack>
              )}
            </>
          ) : (
            <Typography variant="subtitle1">{t(tokens.test.noTest)}</Typography>
          )}
        </Stack>
      )}
    </Stack>
  );
};
